// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const TextHeader = (props) => {

    const textSize = {
        xl: "--xl",
        lg: "--lg",
        md: "--md",
        mdlg: "--mdlg",
        sm: "--sm",
        xs: "--xs",
    };

    return (
        <>
            <CustomBlock>
                <h4 className={`text-header${props.size ? textSize[props.size] : ""} ${props.className ? props.className : ""} ${props.centered ? "centered" : ""}`}>
                    {
                        props.iconLeft &&
                        <CustomBlock className={`text-header-icon-left ${props.iconLeftClassName ? props.iconLeftClassName : ""}`}>
                            {props.iconLeft}
                        </CustomBlock>
                    }
                    {props.title}
                </h4>
                {
                    props.subtitle ? <p className={`text-header-subtitle${props.size ? textSize[props.size] : ""} ${props.subtitleClassName ? props.subtitleClassName : ""}`}>{props.subtitle}</p> : <></>
                }
            </CustomBlock>
        </>
    );
}

TextHeader.propTypes = {
    // APPEARANCE AND SIZE PROPS
    className: PropTypes.string,
    size: PropTypes.string,

    // HEADER PROPS
    title: PropTypes.string,

    // SUBTITLE PROPS
    subtitle: PropTypes.string,
    subtitleClassName: PropTypes.string,

    // ITEM AND ICON PROPS
    iconLeft: PropTypes.object,
    iconLeftClassName: PropTypes.string,

    // BOOLEAN PROPS
    centered: PropTypes.bool,
}

export default TextHeader;